export function toLocalISOString(date: Date, withMS: boolean = false) {
  const tzOffset = date.getTimezoneOffset() * 60_000; // offset in milliseconds
  const fixDate = date.getTime() - tzOffset;
  const isoString = new Date(fixDate).toISOString();
  return withMS ? isoString.slice(0, -1) : isoString.split('.')[0];
}
